
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Mission from './components/Mission';
import Gallery from './components/Gallery';
import Donate from './components/Donate';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/09b42268e64b75a1bdbfb319cdd0d3b1/c1690b0cc28bfbfbc66a79cd89fc0594.png" 
              alt="Cows4Christ Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-2xl font-bold transition-colors ${
              isScrolled ? 'text-[#3E2723]' : 'text-white'
            }`} style={{ fontFamily: 'Playfair Display, serif' }}>
              Cows4Christ
            </span>
          </div>
          
          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-[#3E2723] hover:text-[#5D4037]' : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-[#3E2723] hover:text-[#5D4037]' : 'text-white/90 hover:text-white'
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('mission')}
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-[#3E2723] hover:text-[#5D4037]' : 'text-white/90 hover:text-white'
              }`}
            >
              Mission
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-[#3E2723] hover:text-[#5D4037]' : 'text-white/90 hover:text-white'
              }`}
            >
              Gallery
            </button>
            <button 
              onClick={() => scrollToSection('donate')}
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-[#3E2723] hover:text-[#5D4037]' : 'text-white/90 hover:text-white'
              }`}
            >
              Donate
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap ${
                isScrolled 
                  ? 'bg-[#3E2723] text-white hover:bg-[#5D4037]' 
                  : 'bg-white text-[#3E2723] hover:bg-white/90'
              }`}
            >
              Contact Us
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <div id="home">
        <Hero scrollToSection={scrollToSection} />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="mission">
        <Mission />
      </div>
      <div id="gallery">
        <Gallery />
      </div>
      <div id="donate">
        <Donate />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}
